// extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles-module--sectionContainer--W0xX4"};